exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files \nbody {\n  padding-top: 5rem;\n}\n.starter-template {\n  \n}\n.container-table {\n      position: fixed;\n\n  top: 40%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}*/\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Software Development/Devpark/biz-app/~/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Software Development/Devpark/biz-app/~/postcss-loader?{"ident":"postcss"}!C:/Software Development/Devpark/biz-app/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 8